/** @jsxImportSource @emotion/react */

import ContainerFluid from "components/common/ContainerFluid";
import FooterSideBar from "components/desktop/FooterSideBar";
import { Outlet } from "react-router-dom";

import FooterContentLayoutStyle from "./style.index";

const FooterContentLayout = () => {
  return (
    <>
      <img
        src="https://0kqo9br0eyii.jquut.net/system-requirement/Web.PortalNew/UK254-01/abb6220e97/images/c4cb3352188c75ac1466ad026e7be7ad.jpg"
        alt=""
        css={FooterContentLayoutStyle.bannerImg}
      />
      <ContainerFluid>
        <div css={FooterContentLayoutStyle.wrapper}>
          <FooterSideBar />
          <div css={FooterContentLayoutStyle.mainContent}>
            <Outlet />
          </div>
        </div>
      </ContainerFluid>
    </>
  );
};

export default FooterContentLayout;
